import "./verfiy.css";

function Verify() {
  return (
    <div className="verify">
      <h2>Verify Your Account</h2>
      <p>Enter the 6-digit code sent to your email</p>

      <div className="otp-inputs">
        <input type="text" maxLength="1" />
        <input type="text" maxLength="1" />
        <input type="text" maxLength="1" />
        <input type="text" maxLength="1" />
        <input type="text" maxLength="1" />
        <input type="text" maxLength="1" />
      </div>

      <button className="verify-btn">Verify</button>
    </div>
  );
}

export default Verify;
